import React, { Component } from 'react';

class Offer extends Component {

    componentDidMount(){
        document.body.className = "default";
	}

    render() {
        return (
		<div class="opis-zw">
			<h1>Oferta</h1>
	
			<p>W sklepie proponujemy różnorodne karmy dla psów i kotów, a także szampony, witaminy, obroże, kagańce i inne potrzebne rzeczy. Wygospodarowaliśmy również kącik "dla konia", gdzie znają Państwo duży wybór odżywek oraz preparaty pielęgnacyjne dla swoich rumaków.</p>
	
			<p>Oferujemy pełny zakres usług, z wyszczególnieniem:
				<ul>
					<li>interna</li>
					<li>dermatologia z cytologią, w tym testy alergiczne</li>
					<li>chirurgia</li>
					<li>ortopedia</li>
					<li>anestezjologia (monitoring pacjenta, znieczulenie wziewne)</li>
					<li>stomatologia</li>
					<li>laryngologia</li>
					<li>gastrologia (gastroskopia, w tym konie)</li>
					<li>kardiologia (EKG, echo serca, pomiar ciśnienia)</li>
					<li>RTG</li>
					<li>USG</li>
				</ul>
			</p>
		</div>
        )
    }
}
export default Offer;